import { Button } from "react-bootstrap";



import { useState } from "react";


import BasicInfoEditor from "./BasicInfoEditor";
import AddressEditor from "./AddressEditor";
import ListEditor from "./ListEditor";
import ReferenssitEditor from "./ReferenssitEditor";

export default function UserProfileEditor({
  user,
  onUserChange,
  profile,
  showRole = false,
  roleOptions = [],
  renderBasicExtra,
  renderDevices,
  renderItDevices,
  renderPermissions,
  deviceCount = 0,
  itDeviceCount = 0,

  activeTab: parentActiveTab,
  setActiveTab: setParentActiveTab,
}) {
  const [activeTab, setLocalActiveTab] =
    useState(() => {
      return (
        sessionStorage.getItem(
          "userProfileActiveTab"
        ) ||
        parentActiveTab ||
        "perustiedot"
      );
    });

  const setActiveTab = (tab) => {
    sessionStorage.setItem(
      "userProfileActiveTab",
      tab
    );

    setLocalActiveTab(tab);

    if (setParentActiveTab) {
      setParentActiveTab(tab);
    }
  };

  const tabs = [
    {
      key: "perustiedot",
      label: "Perustiedot",
    },
    {
      key: "osoite",
      label: "Osoite",
    },
    {
      key: "koulutus",
      label: "Koulutus",
      count:
        (profile.koulutukset?.length || 0) +
        (profile.kurssit?.length || 0),
    },
    {
      key: "patevyydet",
      label: "Pätevyydet",
      count:
        profile.patevyydet?.length || 0,
    },
    {
      key: "kielitaito",
      label: "Kielitaito",
      count:
        profile.kielitaidot?.length || 0,
    },
    {
      key: "tyokokemus",
      label: "Työkokemus",
      count:
        profile.tyokokemukset?.length || 0,
    },
    {
      key: "referenssit",
      label: "Referenssit",
      count:
        (profile.referenssit?.length || 0) +
        (profile.yritysReferenssit?.length ||
          0),
    },
  ];

if (renderDevices) {
  tabs.push({
    key: "laitehallinta",
    label: "Laitehallinta",
  });
}

if (renderItDevices) {
  tabs.push({
    key: "it-laitteet",
    label: "IT-laitteet",
  });
}

if (renderPermissions) {
  tabs.push({
    key: "kayttooikeudet",
    label: "Käyttöoikeudet",
  });
}

  return (
    <>
<div
  className="d-flex gap-2 mb-4 flex-wrap"
  style={{
    padding: "8px",
    backgroundColor: "#f4faf4",
    border: "1px solid #e0ebe0",
    borderRadius: "12px",
  }}
>
  {tabs.map((tab) => {
    const active =
      activeTab === tab.key;

    return (
      <Button
  key={tab.key}
  type="button"
  size="sm"
  onClick={() => setActiveTab(tab.key)}
  style={{
    backgroundColor: active
      ? "#04aa00"
      : "#ffffff",

    border: active
      ? "1px solid #04aa00"
      : "1px solid #dce7dc",

    color: active
      ? "#ffffff"
      : "#356535",

    borderRadius: "9px",
    padding: "7px 13px",

    // IMPORTANT
    fontWeight: "600",
    whiteSpace: "nowrap",
    flexShrink: 0,

    boxShadow: active
      ? "0 2px 6px rgba(4,170,0,0.18)"
      : "none",

    transition:
      "background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease",
  }}
      >
        {tab.label}

       {tab.count > 0 && (
  <span
    className="ms-2"
    style={{
      display: "inline-block",
      minWidth: "20px",
      padding: "1px 6px",
      borderRadius: "999px",
      fontSize: "11px",
      textAlign: "center",
      backgroundColor: active
        ? "rgba(255,255,255,0.22)"
        : "#e7f5e7",
      color: active
        ? "#ffffff"
        : "#356535",
    }}
  >
    {tab.count}
  </span>
)}
      </Button>
    );
  })}
</div>

      {activeTab === "perustiedot" && (
  <>
    <BasicInfoEditor
      user={user}
      onChange={onUserChange}
      showRole={showRole}
      roleOptions={roleOptions}
    />

    {renderBasicExtra?.()}
  </>
)}

      {activeTab ===
        "osoite" && (
        <AddressEditor
          user={user}
          onChange={
            onUserChange
          }
        />
      )}

      {activeTab ===
        "koulutus" && (
        <>
          <ListEditor
            title="Koulutus"
            addLabel="Lisää koulutus"

            items={
              profile.koulutukset
            }

            setItems={
              profile.setKoulutukset
            }

            setDeletedIds={
              profile.setDeletedKoulutusIds
            }

            emptyItem={{
              tutkinto: "",
              oppilaitos: "",
              valmistumisvuosi:
                "",
            }}

            getTitle={(item) =>
              item.tutkinto ||
              "Uusi koulutus"
            }

            getSubtitle={(
              item
            ) =>
              item.oppilaitos ||
              ""
            }

            fields={[
              {
                name: "tutkinto",
                label:
                  "Tutkinto",
                md: 5,
              },
              {
                name:
                  "oppilaitos",
                label:
                  "Oppilaitos",
                md: 5,
              },
              {
                name:
                  "valmistumisvuosi",
                label:
                  "Valmistumisvuosi",
                type: "number",
                md: 2,
              },
            ]}
          />

          <div className="mt-5">
            <ListEditor
              title="Kurssit"
              addLabel="Lisää kurssi"

              items={
                profile.kurssit
              }

              setItems={
                profile.setKurssit
              }

              setDeletedIds={
                profile.setDeletedKurssiIds
              }

              emptyItem={{
                kurssi: "",
                jarjestaja: "",
                suoritusvuosi:
                  "",
              }}

              getTitle={(
                item
              ) =>
                item.kurssi ||
                "Uusi kurssi"
              }

              getSubtitle={(
                item
              ) =>
                item.jarjestaja ||
                ""
              }

              fields={[
                {
                  name: "kurssi",
                  label: "Kurssi",
                  md: 5,
                },
                {
                  name:
                    "jarjestaja",
                  label:
                    "Järjestäjä",
                  md: 5,
                },
                {
                  name:
                    "suoritusvuosi",
                  label:
                    "Suoritusvuosi",
                  type: "number",
                  md: 2,
                },
              ]}
            />
          </div>
        </>
      )}

      {activeTab ===
        "patevyydet" && (
        <ListEditor
          title="Pätevyydet"
          addLabel="Lisää pätevyys"

          items={
            profile.patevyydet
          }

          setItems={
            profile.setPatevyydet
          }

          setDeletedIds={
            profile.setDeletedPatevyysIds
          }

          emptyItem={{
            patevyys: "",
            myontaja: "",
            suoritusvuosi: "",
          }}

          getTitle={(item) =>
            item.patevyys ||
            "Uusi pätevyys"
          }

          getSubtitle={(
            item
          ) =>
            item.myontaja ||
            ""
          }

          fields={[
            {
              name: "patevyys",
              label: "Pätevyys",
              md: 5,
            },
            {
              name: "myontaja",
              label: "Myöntäjä",
              md: 5,
            },
            {
              name:
                "suoritusvuosi",
              label:
                "Suoritusvuosi",
              type: "number",
              md: 2,
            },
          ]}
        />
      )}

      {activeTab ===
        "kielitaito" && (
        <ListEditor
          title="Kielitaito"
          addLabel="Lisää kieli"

          items={
            profile.kielitaidot
          }

          setItems={
            profile.setKielitaidot
          }

          setDeletedIds={
            profile.setDeletedKielitaitoIds
          }

          emptyItem={{
            kieli: "",
            taitotaso: "Hyvä",
          }}

          getTitle={(item) =>
            item.kieli ||
            "Uusi kieli"
          }

          getSubtitle={(
            item
          ) =>
            item.taitotaso ||
            ""
          }

          fields={[
            {
              name: "kieli",
              label: "Kieli",
              md: 6,
            },
            {
              name:
                "taitotaso",
              label:
                "Taitotaso",
              md: 6,
              options: [
                "Alkeet",
                "Tyydyttävä",
                "Hyvä",
                "Erinomainen",
                "Äidinkieli",
              ],
            },
          ]}
        />
      )}

      {activeTab ===
        "tyokokemus" && (
        <ListEditor
          title="Työkokemus"
          addLabel="Lisää työkokemus"

          items={
            profile.tyokokemukset
          }

          setItems={
            profile.setTyokokemukset
          }

          setDeletedIds={
            profile.setDeletedTyokokemusIds
          }

          emptyItem={{
            tyotehtava: "",
            yritys: "",
            alkamisvuosi: "",
            paattymisvuosi:
              "",
          }}

          getTitle={(item) =>
            item.tyotehtava ||
            "Uusi työkokemus"
          }

          getSubtitle={(
            item
          ) =>
            item.yritys || ""
          }

          fields={[
            {
              name:
                "tyotehtava",
              label:
                "Työtehtävä",
              md: 4,
            },
            {
              name: "yritys",
              label: "Yritys",
              md: 4,
            },
            {
              name:
                "alkamisvuosi",
              label:
                "Alkamisvuosi",
              type: "number",
              md: 2,
            },
            {
              name:
                "paattymisvuosi",
              label:
                "Päättymisvuosi",
              type: "number",
              md: 2,
            },
          ]}
        />
      )}

      {activeTab ===
        "referenssit" && (
        <ReferenssitEditor
          referenssit={
            profile.referenssit
          }

          setReferenssit={
            profile.setReferenssit
          }

          deletedReferenssit={
            profile.deletedReferenssit
          }

          setDeletedReferenssit={
            profile.setDeletedReferenssit
          }

          yritysReferenssit={
            profile.yritysReferenssit
          }

          setYritysReferenssit={
            profile.setYritysReferenssit
          }

          deletedYritysReferenssit={
            profile.deletedYritysReferenssit
          }

          setDeletedYritysReferenssit={
            profile.setDeletedYritysReferenssit
          }
        />
      )}

      {activeTab ===
        "laitehallinta" &&
        renderDevices?.()}

      {activeTab ===
        "it-laitteet" &&
        renderItDevices?.()}

      {activeTab ===
        "kayttooikeudet" &&
        renderPermissions?.()}
    </>
  );
}